import script from "./jsonViewer.vue?vue&type=script&setup=true&lang=js"
export * from "./jsonViewer.vue?vue&type=script&setup=true&lang=js"

import "./jsonViewer.vue?vue&type=style&index=0&id=39c56771&lang=scss&scoped=true"

import exportComponent from "/root/buildarea/boeingdl-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39c56771"]])

export default __exports__